import * as K from './Keywords'

/** Declared these languages as **English** language. */
export const EnglishDeclaration = [
    'EN', 'PH'
]

export const LanguageCode = {
    [K.Thai]: 'TH',
    [K.English]: 'EN',
    [K.Philippines]: 'PH',
    [K.Vietnamese]: 'VM',
    [K.Bahasa]: 'ID',
    [K.Japanese]: 'JP',
    [K.Korean]: 'KR',
    [K.Hongkong]: 'HK',
    [K.Burmese]: 'MM',
    [K.Khmer]: 'KM',
    [K.Lao]: 'LA',
    [K.Arabic]: 'AR'
}

export const LanguageList = {
    singapore: ['EN'],
    thailand: ['TH', 'EN'],
    japan: ['JP', 'EN'],
    bahrain: ['EN'],
    philippines: ['EN'],
    vietnam: ['VN', 'EN'],
    indonesia: ['ID', 'EN'],
    uae: ['AR', 'EN'],
    taiwan: ['TW', 'EN'],
    hongkong: ['HK', 'EN'],
    cambodia: ['KH', 'EN'],
    malaysia: ['EN'],
    laos: ['LA', 'EN'],
    myanmar: ['EN'],
    australia: ['EN'],
    newzealand: ['EN'],
    korea: ['KR', 'EN'],
    office: ['EN', 'KH', 'LA', 'MM', 'AR'] //, 'DE','FA'
}